import { Component,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { ISortableFilter }          from './../common/sortable-filter';
import { KitchenService }           from './../shared/kitchen.service';
import { PeakService }              from './../shared/peak.service';
import { Observable }               from 'rxjs/Observable';
import { TrainService }             from './../shared/train.service';
import { SortableFilter }           from './../common/sortable-filter';
import { KitchenSortableFilter }    from './kitchen-sortable-filter';
import { KitchenDialogComponent }   from './../kitchen-dialog/kitchen-dialog.component';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { KitchenModel }             from './kitchen.model';
import { MatDialog }                 from '@angular/material';
import { Globals }                  from './../common/globals';


@Component({
  selector: 'sa-kitchen-list',
  template: require('./kitchen-list.component.html'),
  styles: [require('./kitchen-list.component.scss')]
})
export class KitchenListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new KitchenSortableFilter('name');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  public apiService: KitchenService;

  public peakService: PeakService;

  public trainService: TrainService;

  private trains = [];
  private peaks = [];

  private dataReady = false;

  constructor(
    apiService: KitchenService,
    peakService: PeakService,
    trainService: TrainService,
    private dialog: MatDialog,
    public globals: Globals
  ) {
    this.apiService = apiService;
    this.peakService = peakService;
    this.trainService = trainService;
    this.getDataCallback = this.getData.bind(this);
    this.filter.activeOnly = true;

    this.columns = [
      new TableColumn(TableColumnType.Text, 'name', 'Kuchyňka', 100),
      new TableColumn(TableColumnType.Text, 'shopNumber', 'ID', 60),
      new TableColumn(TableColumnType.Text, 'defaultTrainName', 'Default spoj', 150),
      new TableColumn(TableColumnType.Text, 'defaultPeakName', 'Default špička', 160),
      new TableColumn(TableColumnType.Text, 'ipaddress', 'IP adresa', 150),
      new TableColumn(TableColumnType.Text, 'eetRegNumber', 'EET reg. číslo', 100),
      new TableColumn(TableColumnType.Text, 'kitchenTypeName', 'TypKuchyňky', 80),
      new TableColumn(TableColumnType.Bool, 'active', 'Aktivní', 80)
    ];

    Observable.forkJoin(this.peakService.getPeakValues(),
                        this.trainService.getNames(new SortableFilter('trainName')))
                            .subscribe(resp => {
      this.peaks = resp[0];
      this.trains = resp[1];
      this.dataReady = true;
    });
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(KitchenDialogComponent);
    dialogRef.componentInstance.model = new KitchenModel();
    dialogRef.componentInstance.model.trains = this.trains;
    dialogRef.componentInstance.model.peaks = this.peaks;
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: KitchenModel) {
    let dialogRef = this.dialog.open(KitchenDialogComponent);
    model.trains = this.trains;
    model.peaks = this.peaks;
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.kitchenUid, dialogRef.componentInstance.model)
          .subscribe(res => {
            cloakRef.close();
            console.log('Kitchen updated');
            this.search();
          });
      } else if (result === 'delete') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.deleteItem(dialogRef.componentInstance.model.kitchenUid)
          .subscribe(
            data => {
              cloakRef.close();
              console.log('Kitchen deleted');
              this.search();
          },
            err => {
              cloakRef.close();
              window.alert('Vybraná položka nemohla být odstraněna.');
            }
          );
      } else {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/kitchen-list/kitchen-list.component.ts